var platform = new EnsembleVideo.Platform();
platform.InitDeviceScan();

var contentPreview = Class.create({
    debugMode: false,
    // Define the name of the css class that the scsript will look for
    // and add a modal video preview window for
    previewContentSelector: '[class="previewContent"],.previewContent',
    previewUrl: 'sites/index.aspx',
    refereshTimer: '',
    timeOut: '',
    initialize: function() {
        try {

            // For each element that has the 'previewContentSelector' defined,
            // add a function to the click event
            jQuery('.previewContent').on('click', function() {
                contentPreviewInstance.preparePreview(this);
            });
            // Get the ID of the refreshTimer control from the URL of the included .aspx script tag
            //var id = this.getQueryStringValue('refreshTimerID', callerUrl);
            if ($('refreshTimer')) {
                this.refereshTimer = $('refreshTimer').down().readAttribute('id');
            }
        } catch (e) {

        }
    },
    preparePreview: function(e) {
        // Get the element that caused the event
        var element = e;

        if ($(element)) {
            // If the element that triggered the action is an image, set the element to it's parent
            if ($(element).readAttribute("src") != null) element = $(element).up();

            var contentID = $(element).readAttribute('rel');
            var windowTitle = $(element).readAttribute('title');
            windowTitle = this.htmlDecode(windowTitle.unescapeHTML());

            // If the timer control is defined
            if (!this.refereshTimer.empty()) {
                // Stop the page refresh timer
                $find(this.refereshTimer)._stopTimer();
            }

            // Get a token from the server and open the quick publish site
            // with that token and the plugin code
            app.Old_App_Code.DataAccess.Token((function (previewToken) {
                var queryString = '?ContentID=' + contentID + '&Token=' + previewToken + "&isResponsive=true"+
                    "&displayCaptionSearch=true&displayNotes=true&isSharedLibraryContentPreview=" + this.isSharedLibraryContentPreview();
                app.Old_App_Code.DataAccess.CanEmbedAndShareContent(contentID, (function (hasPermission) {
                    if (!hasPermission) {
                        queryString += '&displaySharing=false&displayEmbedCode=false';
                    }
                    this.showPreview(queryString, windowTitle);
                }).bind(this));
            }).bind(this));
        }
    },
    //Decode html to clear text
    htmlDecode: function (html) {
        if (html == null) return '';
        var a = document.createElement('a');
        a.innerHTML = html;
        return a.textContent;
    },
    showPreview: function(contentQueryString, windowTitle) {
        setModalConfig(windowTitle, this.previewUrl + contentQueryString);

        this.hackForiPadScroller();
    },

    getQueryStringValue: function(key, queryString, defaultValue) {
        var hash = $H(queryString.parseQuery());
        var returnValue = '';

        // Convert the query string keys to lower case
        hash.keys().each(function(e) {
            hash.set(e.toLowerCase(), hash.get(e));
        });

        if (typeof (hash.get(key.toLowerCase())) != 'undefined') returnValue = hash.get(key.toLowerCase());
        else if (typeof (defaultValue) != 'undefined') returnValue = defaultValue;

        returnValue = (returnValue == 'false') ? new Boolean(false) : (returnValue == 'true') ? new Boolean(true) : returnValue;

        return returnValue;
    },
    log: function(message) {
        if (this.debugMode == true) {
            try {
                console.log(message);
            } catch (e) {
            }
        }
    },
    hackForiPadScroller: function() {
        if (!platform.isIos)
            return;

        if ($('MB_frame')) {
            $('MB_frame').addClassName('MB_frame_fix_for_iPad');

            clearTimeout(this.timeOut);
        } else {
            this.timeOut = setTimeout(this.hackForiPadScroller, 1000);
        }
    },
    isSharedLibraryContentPreview: function () {
        return location.href.toLowerCase().indexOf('sharedlibrary.aspx') > -1;
    }
});

// Create an instance of the object after the page has loaded
document.observe('dom:loaded', function () {
    contentPreviewInstance = new contentPreview();

    // Clear modal iframe settings on modal close event
    jQuery('#myModal').on('hide.bs.modal', function(e) {
        jQuery(".modal-title").text('');
        jQuery("#modalIframe").attr("src", '');
        jQuery("#modalIframe").css("height", '150px');
    });
});

function setModalConfig(modalTitle, iFrameSrc) {
    jQuery("#modalLabel").text(modalTitle);
    jQuery("#modalIframe").attr("src", iFrameSrc);
    jQuery("#myModal").modal();
}